module.exports = "./img/ebad87e60a668cbadeea6a7efaf9b7ce.jpg";